import Checkbox from "components/controls/checkbox";
import { useClickOutside } from "hooks/click-outside";
import moment from "moment";
import { Moment } from "moment";
import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { RootState } from "types";
import "./filter.scss";

function Filter({ open, setOpen, buttonRef }: { open: boolean; setOpen: any; buttonRef: any }) {
    const ref = useRef<any>();
    const history = useHistory();
    const project = useSelector((state: RootState) => state.project);
    const search = new URLSearchParams(window.location.search);
    const [dateFrom, setDateFrom] = useState<Moment>(moment(search.get("datefrom")));
    const [dateTo, setDateTo] = useState<Moment>(moment(search.get("dateto")));
    const [streams, setStreams] = useState<number[]>(
        search
            .get("streams")!
            .split(",")
            .filter((x) => x !== "10")
            .map((x) => parseInt(x))
    );

    useClickOutside([ref, buttonRef], () => setOpen(false));

    const quickDateSelect = (val: number) => {
        switch (val) {
            case 1:
                setDateFrom(moment().set("hours", 0).set("minutes", 0).set("seconds", 0));
                setDateTo(moment());
                break;
            case 2:
                setDateFrom(moment().subtract(1, "day").set("hours", 0).set("minutes", 0).set("seconds", 0));
                setDateTo(moment().set("hours", 0).set("minutes", 0).set("seconds", 0).subtract(1, "second"));
                break;
            case 3:
                setDateFrom(moment().subtract(1, "day").set("hours", 0).set("minutes", 0).set("seconds", 0));
                setDateTo(moment());
                break;
            case 4:
                setDateFrom(moment().subtract(6, "day").set("hours", 0).set("minutes", 0).set("seconds", 0));
                setDateTo(moment());
                break;
            case 5:
                setDateFrom(moment().subtract(13, "day").set("hours", 0).set("minutes", 0).set("seconds", 0));
                setDateTo(moment());
                break;
            case 6:
                setDateFrom(moment().subtract(29, "day").set("hours", 0).set("minutes", 0).set("seconds", 0));
                setDateTo(moment());
                break;
            case 7:
                setDateFrom(moment().set("date", 1).set("hours", 0).set("minutes", 0).set("seconds", 0));
                setDateTo(moment());
                break;
            case 8:
                setDateFrom(moment().subtract(1, "month").set("date", 1).set("hours", 0).set("minutes", 0).set("seconds", 0));
                setDateTo(moment().set("date", 1).set("hours", 0).set("minutes", 0).set("seconds", 0).subtract(1, "second"));
                break;
        }
    };

    const getStreamName = (streamId: string) => {
        switch (streamId) {
            case "7":
                return "x-twitter";
            case "8":
                return "facebook";
            case "9":
                return "instagram";
            case "10":
                return "youtube";
            case "11":
                return "linkedin";
        }
    };

    const toggleStream = (id: number) => {
        if (id === 10 && !streams.includes(10)) {
            setStreams([10]);
        } else if (id !== 10 && streams.includes(10)) {
            setStreams([id]);
        } else {
            if (streams.includes(id)) {
                setStreams(streams.filter((x) => x !== id));
            } else {
                setStreams([...streams, id]);
            }
        }
    };

    const submit = () => {
        search.set("datefrom", dateFrom.format("YYYY-MM-DD"));
        search.set("dateto", dateTo.format("YYYY-MM-DD"));
        search.set("streams", streams.join(","));
        history.replace({
            search: `?${search.toString()}`,
        });
        setOpen(false);
    };

    return (
        <div className={`filter${open ? " open" : ""}`} ref={ref}>
            <div className="filters-menu-section date">
                <p className="filters-menu-section-heading">Date Range</p>
                <div className="filters-menu-section-body">
                    <div className="input-group date-from">
                        <input type="date" value={dateFrom.format("YYYY-MM-DD")} onChange={(e) => setDateFrom(moment(e.currentTarget.value))} />
                    </div>
                    <span>-</span>
                    <div className="input-group">
                        <input type="date" value={dateTo.format("YYYY-MM-DD")} onChange={(e) => setDateTo(moment(e.currentTarget.value))} />
                    </div>
                    <div className="quick-dates">
                        <span onClick={() => quickDateSelect(1)}>Today</span>
                        <span onClick={() => quickDateSelect(2)}>Yesterday</span>
                        <span onClick={() => quickDateSelect(3)}>Last 2 Days</span>
                        <span onClick={() => quickDateSelect(4)}>Last 7 Days</span>
                        <span onClick={() => quickDateSelect(5)}>Last 14 Days</span>
                        <span onClick={() => quickDateSelect(6)}>Last 30 Days</span>
                        <span className="quick-date-2" onClick={() => quickDateSelect(7)}>
                            This Month
                        </span>
                        <span className="quick-date-2" onClick={() => quickDateSelect(8)}>
                            Last Month
                        </span>
                    </div>
                </div>
            </div>
            <div className="filters-menu-section streams">
                <p className="filters-menu-section-heading">Streams</p>
                <div className="filters-menu-section-body">
                    {project.StreamId.toString()
                        .split(",")
                        .map((x) => {
                            return (
                                <div className="input-group" key={x}>
                                    <label htmlFor={`stream-${x}`}>
                                        <i className={`fab fa-${getStreamName(x)}`}></i>
                                    </label>
                                    <Checkbox id={`stream-${x}`} checked={streams.includes(parseInt(x))} onChange={() => toggleStream(parseInt(x))} disabled={streams.length === 1 && streams.includes(parseInt(x))} />
                                </div>
                            );
                        })}
                </div>
            </div>
            <button className="submit" onClick={submit}>
                Submit
            </button>
        </div>
    );
}

export default Filter;
